// Copied verbatim from eval/dashboard/internal_web/src/lib/motion.ts (ATM-57). Keep in step until ATM-60 shares it.
/** The reader's motion preference, read the one way every scroll and animation here honours it. */

/** Whether the reader asked the system for reduced motion. */
export function prefersReducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** How a programmatic scroll should move: instantly for a reader who asked for less motion. */
export function scrollBehavior(): ScrollBehavior {
  return prefersReducedMotion() ? "auto" : "smooth";
}
